'use client';

import { useState } from 'react';
import { Box } from '@terra/ui-styled-system';
import { useTranslations } from 'next-intl';
import type { WebAppSuggestedApplicationDto } from '@terra/shared-contracts-external-network';
import { Button } from '../../../../components/button';
import { WebAppClusterLinkSelect } from './WebAppClusterLinkSelect';
import type { LinkableWebApplication } from './web-app-types';

export type AfterFactWebAppClusterLinkProps = {
  applications: LinkableWebApplication[];
  suggestion?: WebAppSuggestedApplicationDto | null;
  onLinkExisting?: (applicationId: string) => void;
};

export function AfterFactWebAppClusterLink({
  applications,
  suggestion,
  onLinkExisting,
}: AfterFactWebAppClusterLinkProps) {
  const tShared = useTranslations(
    'designSystem.networkSettings.externalInventory.shared',
  );
  const [pendingApplicationId, setPendingApplicationId] = useState(
    suggestion?.id ?? '',
  );
  const applicationIdToLink = pendingApplicationId || suggestion?.id;

  return (
    <Box w="full">
      <WebAppClusterLinkSelect
        applications={applications}
        value={pendingApplicationId}
        onValueChange={setPendingApplicationId}
      />
      {applicationIdToLink ? (
        <Button
          size="xs"
          variant="outline"
          mt={2}
          onClick={(event) => {
            event.stopPropagation();
            onLinkExisting?.(applicationIdToLink);
          }}
        >
          {tShared('confirm')}
        </Button>
      ) : null}
    </Box>
  );
}
